import {
  mdiAccountMultipleOutline,
  mdiCardAccountDetailsOutline,
  mdiFileDocumentMultipleOutline,
  mdiHammerScrewdriver,
  mdiSchool,
  mdiMapSearchOutline,
  mdiFileChartOutline
} from '@mdi/js'

export default [

  // { title: 'common.home', icon: mdiHomeOutline, to: 'home' },
  { title: 'common.reports', icon: mdiFileChartOutline, to: 'reports' },
  {subheader: 'common.eval_subheader' },
  { title: 'common.qip', icon: mdiFileDocumentMultipleOutline, to: 'evaluations' },
  // { title: 'Resultados', icon: mdiChartBar, to: 'results' },
  { title: 'common.instruments', icon: mdiHammerScrewdriver, to: 'instruments' },
  {subheader: '' },
  { title: 'common.users', icon: mdiAccountMultipleOutline, to: 'users' },
  { title: 'common.schools', icon: mdiSchool, to: 'schools' },
  { title: 'common.zones', icon: mdiMapSearchOutline, to: 'zones' },
  // {subheader: 'FAQs' },
  // { title: 'Tutorial', icon: mdiVideoVintage, to: 'tutorial' },

]
